<template>
    <div
        v-if="lang == 'de'"
        lang="de"
        class="border small mb-1 p-2"
        style="background-color: rgba(0, 0, 0, 0.03); hyphens: auto"
    >
        <strong>Hinweis:</strong>
        Die Forschungslandkarte und die ihr zu Grunde liegende Datenbank
        umfassen und bilden gegenwärtig den Datenbestand des Vorgängerprojektes
        <a href="https://flucht-forschung-transfer.de/">
            Flucht: Forschung und Transfer
        </a>
        ab. Erfasst wurden relevante Projekte der Flucht- und
        Flüchtlingsforschung in Deutschland, die im Zeitraum 2011 bis 2018
        begonnen und oder abgeschlossen wurden. Im Rahmen des FFVT Projektes
        wird diese Datenbank kontinuierlich fortgeschrieben und gegenwärtig
        aktualisiert.
    </div>

    <div 
        v-if="lang == 'en'"
        lang="en"
        class="border small mb-1 p-2"
        style="background-color: rgba(0, 0, 0, 0.03); hyphens: auto"
    >
        <strong>Hint:</strong>
        The research map and the database on which it is based currently comprise and form the
        database of the predecessor project
        <a href="https://flucht-forschung-transfer.de/">Flight: Research and Knowledge Transfer</a>.
        It covers relevant projects in the field of flight and refugee research in Germany
        that were started and/or completed between 2011 and 2018. Within the FFVT project,
        this database is continuously updated and currently being updated.
        A large part of the information is currently only available in German. In the course of the update
        the contents should also be provided in English.
    </div>

</template>

<script>
export default {
    props: {
        lang: {
            type: String,
            default: () => 'de'
        }
    }
}
</script>